module.exports = __webpack_public_path__ + "img/vtcwm101_center_001.d196b97c.png";